export default "__VITE_ASSET___BkBW3gb__"